import { render, staticRenderFns } from "./addPresale.vue?vue&type=template&id=104ac45e&scoped=true&"
import script from "./addPresale.vue?vue&type=script&lang=js&"
export * from "./addPresale.vue?vue&type=script&lang=js&"
import style0 from "./addPresale.vue?vue&type=style&index=0&id=104ac45e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104ac45e",
  null
  
)

export default component.exports